/*jslint browser: true */
/*global window:false, ko:false, $:false */

;(function () {
    "use strict";

    var FirmAd = function(options, $root) {
        var model;

        model = this;
        model.uid = $root.data('firm-promo-uid');
        model.id = ko.observable(0).extend({ numeric: 0 });
        model.content = ko.observable('');
        model.image_url = ko.observable('');
        model.photo_id = ko.observable(0).extend({ numeric: 0 });
        model.is_enabled = ko.observable(false);
        model.moderate_status = ko.observable('');
        model.locations = ko.observableArray([]);

        model.save_url = options.save_url;
        model.delete_url = options.delete_url;

        model.errors = ko.observable(null);
        model.progress = ko.observable(true);
        model.is_edit = ko.observable(false);
        model.rules_showed = ko.observable(false);

        model.save = function() {
            model.hideErrors();
            $.ajax(
                {
                    url: model.save_url,
                    method: 'POST',
                    data: model.getData()
                }
            )
                .done(function(data) {
                    if (data && data.id) {
                        if (!model.id() > 0) {
                            model.id(data.id);
                        }
                        if (data.moderate_status) {
                            model.moderate_status(data.moderate_status);
                        }
                        model.is_edit(false);

                        Toasts.pushToast('Ваше объявление отправлено на модерацию. Вы получите личное сообщение о статусе модерации', 'success');
                    } else {
                        model.showErrors({global: 'Что-то пошло не так. Попробуйте повторить попытку.'});
                    }
                })
                .fail(function(xhr, data) {
                    var errors = typeof xhr.responseJSON != 'undefined' ? xhr.responseJSON.errors : {};
                    if (_.isEmpty(errors)) {
                        errors = {global: 'Что-то пошло не так. Попробуйте повторить попытку.'};
                    }
                    model.showErrors(errors);
                })
            ;
        };

        model.deleteAd = function() {
            model.hideErrors();
            $.ajax(
                {
                    url: model.delete_url,
                    method: 'POST',
                    data: { id: model.id() }
                }
            )
                .done(function(data) {
                    if (data && data.success) {
                        model.updateData({});
                        model.is_edit(false);
                        Toasts.pushToast('Ваше объявление удалено', 'success');
                    } else {
                        model.showErrors({global: 'Что-то пошло не так. Попробуйте повторить попытку.'});
                    }
                })
                .fail(function(xhr, data) {
                    var errors = typeof xhr.responseJSON != 'undefined' ? xhr.responseJSON.errors : {};
                    if (_.isEmpty(errors)) {
                        errors = {global: 'Что-то пошло не так. Попробуйте повторить попытку.'};
                    }
                    model.showErrors(errors);
                })
            ;
        };

        model.hideErrors = function() {
            model.errors(null);
        };

        model.showErrors = function(errors) {
            model.errors(errors);
        };

        model.edit = function() {
            model.is_edit(true);
        };
        
        model.getData = function() {
            var data = {
                id: model.id(),
                content: model.content(),
                is_enabled: model.is_enabled() ? 1 : 0,
                photo_id: model.photo_id(),
                locations: []
            };
            model.locations().map(function(location) {
                data.locations.push(location.getData());
            });

            return data;
        };

        model.exists = ko.computed(function() {
            return model.id() > 0;
        }, model);

        model.addLocation = function() {
            model.locations.push(new ProfileFirmAdLocation(model, {}));
        };

        model.deleteLocation = function(location) {
            model.locations.remove(location);
        };

        model.getLocationsById = function(id) {
            return model.locations().filter(function(location) {
                return location.id() == id;
            });
        };

        model.deletePhoto = function() {
            model.photo_id(0);
            model.image_url('');
        };

        model.updateData = function(data) {
            model.id(data.id);
            model.content(data.content ? data.content : '');
            model.moderate_status(data.moderate_status ? data.moderate_status : '');
            model.image_url(data.image_url ? data.image_url : '');
            model.photo_id(data.photo_id);
            model.is_enabled(data.is_enabled ? true : false);
            var locations = [];
            if (data.locations && data.locations.length) {
                locations = data.locations.map(function(locationOptions) {
                    return new ProfileFirmAdLocation(model, locationOptions);
                });
            }
            model.locations(locations);
        };

        model.applySelect2ToLocation = function(elements) {
            elements.map(function(element) {
                var $element = $(element);
                var $citySelectorFields = $element.find('.city-selector_template');
                if ($citySelectorFields.length) {
                    $citySelectorFields.each(function() {
                        $(this).removeClass('city-selector_template').addClass('city-selector');
                        $(document).trigger('CitySelector::Init', [$(this)]);
                        $(this).on('change', function(e) {
                            if (typeof e.added != 'undefined') {
                                var newData = e.added;
                                var locations = model.getLocationsById(newData.id);
                                locations.map(function(location) {
                                    location.updateLoadedData(newData);
                                });

                                var $select2Fields = $(this).closest('.firm-promo__management-edit__location').find('.select2_template');
                                if ($select2Fields.length) {
                                    $select2Fields.each(function() {
                                        $(this).removeClass('select2_template').addClass('select2');
                                        $(document).trigger('Select2::Init', [$(this)]);
                                    });
                                }
                            }
                        });
                    });
                }

                var $select2Fields = $element.find('.select2_template');
                if ($select2Fields.length) {
                    $select2Fields.each(function() {
                        $(this).removeClass('select2_template').addClass('select2');
                        $(document).trigger('Select2::Init', [$(this)]);
                    });
                }
            });
        };

        model.toggleRules = function() {
            if (model.rules_showed() == true) {
                model.rules_showed(false);
            } else {
                model.rules_showed(true);
            }
        };

        $(document).trigger('PhotoUploadOverlay::registerCallback', [
            {
                name: 'set-firm-ad-photo-' + model.uid,
                callbackFunction: function ($caller, photos, ideabook, size, isLast) {

                    $(document).trigger('PhotoUploadOverlay::hide');

                    var photo = photos[0];
                    if (typeof photo != 'undefined') {
                        model.photo_id(photo.id);
                        model.image_url(photo.src);
                    } else {
                        model.deletePhoto();
                    }
                }
            }
        ]);

        model.updateData(options);

        $root.removeClass('firm-promo__management_hidden');
    };

    window.FirmAdsViewModel = FirmAd;

    ko.extenders.numeric = function(target, precision) {
        //create a writable computed observable to intercept writes to our observable
        var result = ko.pureComputed({
             read: target,  //always return the original observables value
             write: function(newValue) {
                 var current = target(),
                     roundingMultiplier = Math.pow(10, precision),
                     newValueAsNum = isNaN(newValue) ? 0 : parseFloat(+newValue),
                     valueToWrite = Math.round(newValueAsNum * roundingMultiplier) / roundingMultiplier;

                 //only write if it changed
                 if (valueToWrite !== current) {
                     target(valueToWrite);
                 } else {
                     //if the rounded value is the same, but a different value was written, force a notification for the current field
                     if (newValue !== current) {
                         target.notifySubscribers(valueToWrite);
                     }
                 }
             }
         }).extend({ notify: 'always' });

        //initialize with current value to make sure it is rounded appropriately
        result(target());

        //return the new computed observable
        return result;
    };
})();